import Cookies from 'js-cookie'

function isPhone() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag === null;
}

const state = {
  menuCollapse: false,
  studentType: localStorage.getItem("studentType") || "null",
  applicationId: localStorage.getItem("applicationId") || "",
  cardId: localStorage.getItem("cardId") || "",
  user: "null",
  permission: [],
  device: null,
  isPhone: isPhone(),
};
const mutations = {
  set_device(state, val) {
    state.device = val;
  },
  set_menuCollapse(state, val) {
    state.menuCollapse = val;
  },
  set_studentType(state, val) {
    localStorage.setItem("studentType", val);
    state.studentType = val;
  },
  set_user(state, val) {
    state.user = val;
  },
  set_applicationId(state, val) {
    localStorage.setItem("applicationId", val);
    state.applicationId = val;
  },
  set_cardId(state, val) {
    localStorage.setItem("cardId", val);
    state.cardId = val;
  },
  set_permission: (state, permission) => {
    state.permission = permission;
  },

};
const actions = {

};
const getters = {};

// 不要忘记把state, mutations等暴露出去。
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
